import React, {useState} from "react";
import PropTypes from "prop-types";
import {makeStyles, Grid, Typography, Box, Popover, Container, IconButton} from "@material-ui/core";
import {CloseIcon} from "@hapinest/theme";
import AccessibleIcon from "../../widget/streamline-icon/AccessibleIcon";
import ApartmentShowMoreContent from "./ApartmentShowMoreContent";

const useStyles = makeStyles((theme) => ({
    popContainer: {
        width: "486px",
        minHeight: "auto",
        padding: theme.spacing(2.625, 2.25),
        overflow: "hidden"
    },
    marginTop: {
        marginTop: -theme.spacing(1.875)
    },
    title: {
        display: "inline-flex",
        width: "100%",
        alignItems: "center",
        marginBottom: theme.spacing(2)
    },
    iconBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${theme.palette.text.white}`,
        background: theme.palette.text.link,
        width: theme.spacing(2.25),
        height: theme.spacing(2.25),
        "& i": {
            display: "flex",
            color: theme.palette.text.white,
            fontSize: theme.spacing(1.25)
        }
    },
}));

const ApartmentShowMorePopover = ({anchorEl, closePop, apartment, apartmentShowMore, children, ...props}) => {

    const classes = useStyles();

    const open = Boolean(anchorEl);

    const [vertical, setVertical] = useState(80);

    const handleClose = () => {
        setVertical("top");
        closePop();
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical,
                horizontal: "center",
            }}
            {...props}
        >
            <Container
                className={classes.popContainer}
            >
                <Grid
                    container
                    direction="row"
                    spacing={0}
                >
                    <Grid
                        item
                        md={11}
                        lg={11}
                        xs={11}
                        sm={11}
                        className={classes.title}
                    >
                        <Typography variant={"h6"}>
                            {apartment?.apartment_size_name + " " + apartment?.apartment_name}
                        </Typography>

                        {apartment?.wheelchair_accessibility &&
                            <Box
                                className={classes.iconBox}
                                ml={1.5}
                                mt={-0.3}
                            >
                                <AccessibleIcon />
                            </Box>
                        }
                    </Grid>

                    <Grid
                        item
                        md={1}
                        lg={1}
                        xs={1}
                        sm={1}
                    >
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            className={classes.marginTop}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>

                <ApartmentShowMoreContent
                    apartmentShowMore={apartmentShowMore}
                    apartmentExtraBed={apartment?.extra_bed}
                    apartmentWheelchair={apartment?.wheelchair_accessibility}
                />

                {children}
            </Container>
        </Popover>


    );
};

ApartmentShowMorePopover.propTypes = {
    anchorEl: PropTypes.any,
    closePop: PropTypes.func,
    apartment: PropTypes.object,
    apartmentShowMore: PropTypes.object,
    children: PropTypes.any
};

export default ApartmentShowMorePopover;
